export default {"componentDescription":"","propDescriptions":{},"classDescriptions":{},"slotDescriptions":{"sendButton":""}};